import React, { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

const WEDDING_DATE = new Date("2026-11-28T16:00:00-06:00");

const calc = () => {
  const diff = Math.max(0, WEDDING_DATE.getTime() - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
};

const Countdown = () => {
  const { t } = useLanguage();
  const [time, setTime] = useState(calc());

  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const cells = [
    { label: t.hero.countdown.days, value: time.days },
    { label: t.hero.countdown.hours, value: time.hours },
    { label: t.hero.countdown.minutes, value: time.minutes },
    { label: t.hero.countdown.seconds, value: time.seconds },
  ];

  return (
    <div data-testid="countdown" className="flex items-stretch gap-4 md:gap-10">
      {cells.map((c, i) => (
        <div key={c.label} className="flex items-center">
          <div className="text-center min-w-[58px]">
            <div className="font-serif text-3xl md:text-5xl text-white tabular-nums">
              {String(c.value).padStart(2, "0")}
            </div>
            <div className="text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-white/80 mt-2">
              {c.label}
            </div>
          </div>
          {i < cells.length - 1 && (
            <div className="ml-4 md:ml-10 w-px h-10 md:h-14 bg-white/30" />
          )}
        </div>
      ))}
    </div>
  );
};

export default Countdown;
